import React from "react";
import SelectMenu from "../../../../../library/custom/selectMenu/SelectMenu";
import FormLabels from "../../../../../library/custom/formLabel/FormLabels";
import { Grid } from "@mui/material";
import { YES_NO } from "../../../../../constant/constant";
import FormControl from "@mui/material/FormControl";

const TopTwoQuestion = (props) => {
  const twoQuesHandler = (value, insCQ) => {
    const confAns = value;
    props?.setSwInspectionConfQuestionAns((prevState) => {
      const existingQuestion = prevState.find(
        (item) => item.confQuesId === insCQ.key
      );
      if (existingQuestion) {
        return prevState.map((item) =>
          item.confQuesId === insCQ.key ? { ...item, confAns: confAns } : item
        );
      } else {
        return [
          ...prevState,
          {
            confQuesId: insCQ.key,
            confAns: confAns,
          },
        ];
      }
    });
  };

  const allQuestionsAnswered = props?.isNorthCarolina ? props?.getSwReference?.InsConfQuesList?.slice(
    2,
    4
  )?.every((insCQ) =>
    props?.swInspectionConfQuestionAns?.some(
      (item) => item.confQuesId === insCQ.key && item.confAns
    )
  ) : props?.getSwReference?.InsConfQuesList?.slice(
    4,
    6
  )?.every((insCQ) =>
    props?.swInspectionConfQuestionAns?.some(
      (item) => item.confQuesId === insCQ.key && item.confAns
    )
  );
  const showTopQuestion = props?.isNorthCarolina ? props?.getSwReference?.InsConfQuesList?.slice(2, 4) :props?.getSwReference?.InsConfQuesList?.slice(4, 6);
  return (
    <>
      <Grid container>
        <Grid item md={12} className="northCarolinaOverride" mt={2}>
          <div className="twoQuestionBox">
            {showTopQuestion?.map(
              (insCQ) => {
                const selectedAnswer = props?.swInspectionConfQuestionAns?.find(
                  (item) => item.confQuesId === insCQ.key
                )?.confAns;
                return (
                  <div className="twoQuestionList" key={insCQ?.key}>
                    <Grid item md={7} xs={12}>
                      <FormControl fullWidth>
                        <FormLabels label={insCQ?.value} isRequired={true} />
                        <SelectMenu
                          placeholder="Please Select"
                          listData={YES_NO ?? []}
                          value={selectedAnswer ?? ""}
                          onchangehandler={(e) =>
                            twoQuesHandler(e.target.value, insCQ)
                          }
                        />
                      </FormControl>
                    </Grid>
                  </div>
                );
              }
            )}
            {!allQuestionsAnswered && props?.twoQuestionError && (
              <Grid item md={12} mb={2}>
                <p className="error">
                  Please answer all required inspection confirmation questions.
                </p>
              </Grid>
            )}
          </div>
        </Grid>
      </Grid>
    </>
  );
};

export default TopTwoQuestion;
